import Props from "./props";
import React from "react";
import getProfessionFieldSelector from "../../../../state/selectors/ProfessionSelectors/getProfessionFieldSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const ProfessionCell: React.FC<Props> = ({ label, field }) => {
    const savedValue = useSelector((state: Store) => getProfessionFieldSelector(state, field));
    return (
        <FlexWrapper>
            <Left>{label}</Left>
            <Right dangerouslySetInnerHTML={{ __html: savedValue }} />
        </FlexWrapper>
    );
};

export default ProfessionCell;

const FlexWrapper = styled.div`
    display: flex;
    padding-bottom: 2rem;
`;

const Left = styled.div`
    width: 23%;
    font-weight: 700;
    font-size: 1.1rem;
    padding: 0 0.5rem;
    text-align: left;
    @media print {
        font-size: 1rem;
    }
`;

const Right = styled.div`
    flex: 1;
    font-size: 1.1rem;
    padding: 0 0.5rem;
    text-align: justify;
    word-break: break-word;
    @media print {
        font-size: 1rem;
    }
    p {
        margin-bottom: 0.5rem;
    }
    textarea {
        font-weight: 100;
        padding: 0.5rem;
    }
`;
